angular.module('mercury.modules.qa.menumate', [
  'mercury.modules.qa.menumate.billpayments',
  'mercury.modules.qa.menumate.billtenders',
  'mercury.modules.qa.menumate.cancelledsaleslines',
  'mercury.modules.qa.menumate.consumptionreport',
  'mercury.modules.qa.menumate.discountlines',
  'mercury.modules.qa.menumate.salesline'
]);
